import Vue from 'vue';
import draggable from 'vuedraggable'

import Elements from "./Elements";
import Properties from "./Properties"
import TextComponent from './TextComponent';
import NumberComponent from './NumberComponent'
import SelectComponent from './SelectComponent'
import RadioComponent from './RadioComponent'
import CheckboxComponent from './CheckboxComponent'
import DatepickerComponent from './DatepickerComponent'
import TableComponent from './TableComponent'
import DocumentComponent from './DocumentComponent'
import TitleComponent from './TitleComponent'
import AppendicesComponent from './AppendicesComponent'
import ParagraphComponent from './ParagraphComponent'
import SeparatorComponent from './SeparatorComponent'
import ChartComponent from './ChartComponent'
import QuizzComponent from './QuizzComponent'

export const FormBuilder = new Vue({
    components : { draggable, Elements, Properties, TextComponent, NumberComponent, SelectComponent, RadioComponent, CheckboxComponent, DatepickerComponent, TableComponent, DocumentComponent, TitleComponent, AppendicesComponent, ParagraphComponent, SeparatorComponent, ChartComponent, QuizzComponent },
    data() {
        return {
            fields: [
                {
                    'component': 'TextComponent',
                    'text': 'Saisie de texte',
                    'icon' : 'far fa-pen-alt',
                    'legend' : '',
                    'hasOptions': false,
                    'required': false,
                    'helper' : '',
                    'type' : 'data'
                },
                {
                    'component': 'NumberComponent',
                    'text': 'Saisie numérique',
                    'icon' : 'far fa-sort-numeric-down',
                    'value' : 0,
                    'hasOptions': false,
                    'required': false,
                    'helper' : '',
                    'type' : 'data'
                },
                {
                    'component': 'DatepickerComponent',
                    'text': 'Saisie de date',
                    'format' : 'date',
                    'value' : '',
                    'icon' : 'far fa-calendar',
                    'hasOptions': false,
                    'required': false,
                    'helper' : '',
                    'type' : 'data'
                },
                {
                    'component': 'SelectComponent',
                    'text': 'Choix à sélection',
                    'value' : '',
                    'icon' : 'far fa-list',
                    'hasOptions': true,
                    'required': false,
                    'helper' : '',
                    'type' : 'data'
                },
                {
                    'component': 'RadioComponent',
                    'text': 'Choix unique',
                    'value' : '',
                    'icon' : 'far fa-check-circle',
                    'hasOptions': true,
                    'required': false,
                    'helper' : '',
                    'type' : 'data'
                },
                {
                    'component': 'CheckboxComponent',
                    'text': 'Choix multiple',
                    'value' : '',
                    'icon' : 'far fa-check-square',
                    'hasOptions': true,
                    'required': false,
                    'helper' : '',
                    'type' : 'data'
                },
                {
                    'component': 'TableComponent',
                    'text': 'Tableau',
                    'icon' : 'far fa-table',
                    'hasOptions': false,
                    'header' : true,
                    'helper' : '',
                    'type' : 'data'
                },
                {
                    'component': 'DocumentComponent',
                    'text': 'Envoi de documents',
                    'icon' : 'far fa-file-upload',
                    'hasOptions': false,
                    'required': false,
                    'helper' : '',
                    'type' : 'data'
                },
                {
                    'component': 'ChartComponent',
                    'text': 'Graphique',
                    'icon' : "far fa-chart-area",
                    'hasOptions': false,
                    'helper' : '',
                    'type' : 'data'
                },
                {
                    'component' : 'TitleComponent',
                    'text' : 'Titre',
                    'icon' : 'far fa-font',
                    'type' : 'text'
                },
                {
                    'component' : 'ParagraphComponent',
                    'text' : 'Paragraphe',
                    'icon' : 'far fa-paragraph',
                    'type' : 'text'
                },
                {
                    'component': 'AppendicesComponent',
                    'text': 'Annexes',
                    'icon' : "far fa-file",
                    'hasOptions': false,
                    'helper' : '',
                    'show_pdf': false,
                    'type' : 'text',
                },
                {
                    'component' : 'SeparatorComponent',
                    'text' : 'Saut de page',
                    'icon' : 'far fa-grip-lines',
                    'type' : 'text'
                },
                {
                    'component' : 'QuizzComponent',
                    'text' : 'Questionnaire',
                    'icon' : 'far fa-question',
                    'type' : 'data'
                }
            ],
            sortElementOptions: {
                group: { name:'formbuilder', pull:false, put:true },
                sort: true,
            },
            dropElementOptions: {
                group: { name:'formbuilder', pull:'clone', put:false },
                sort: false,
            }
        }
    },
    methods : {
        deleteElement(index){
            vm.$store.activeForm = [];
            this.$delete(vm.$store.forms, index);
        },
        editElementProperties(form , index){
            vm.$store.activeForm = form;
            $('#propertiesModal').modal({'backdrop': 'static'})
            $('#settings-tab').tab('show');
        },
        duplicateElement(form , index){
            vm.$store.activeForm = form;
        }
    }
})
